import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/_auth/procurement/order-suggestions/")({
  loader: ({ location }) => {
    if (location.pathname === "/procurement/order-suggestions") {
      throw redirect({
        to: "/procurement/order-suggestions/replenishment-suggestions",
      })
    }
    return null
  },
})
